module.exports = __webpack_public_path__ + "img/blue-mind.png";